<template>
  <div @click="selectConversation">
    <a-row
      class="conversation-item-container"
      type="flex"
      align="middle"
      :gutter="10"
      :class="{
        choose:
          conversation.conversationID === currentConversation.conversationID
      }"
    >
      <!-- <a-icon class="close-btn" type="close" title="删除会话"></a-icon> -->
      <a-col span="5">
        <a-avatar
          size="large"
          shape="square"
          :src="avatar || face"
          :type="conversation.type"
        />
      </a-col>
      <a-col span="19">
        <a-row type="flex" justify="space-between" align="middle">
          <a-col class="text-ellipsis name" span="16">
            <span
              :title="
                conversation.userProfile.nick || conversation.userProfile.userID
              "
              v-if="conversation.type === $TIM.TYPES.CONV_C2C"
              >{{
                conversation.userProfile.nick || conversation.userProfile.userID
              }}</span
            >
            <span
              :title="
                conversation.groupProfile.name ||
                  conversation.groupProfile.groupID
              "
              v-else-if="conversation.type === $TIM.TYPES.CONV_GROUP"
              >{{
                conversation.groupProfile.name ||
                  conversation.groupProfile.groupID
              }}</span
            >
            <span v-else-if="conversation.type === $TIM.TYPES.CONV_SYSTEM"
              >系统通知</span
            >
          </a-col>
          <a-col class="unread-count">
            <a-badge :count="conversation.unreadCount"></a-badge>
          </a-col>
        </a-row>
        <a-row type="flex" justify="space-between" align="middle">
          <a-col span="16">
            <div v-if="conversation.lastMessage" class="text-ellipsis msg">
              <span class="remind" style="color:red;" v-if="hasMessageAtMe"
                >[有人提到我]</span
              >
              <span
                class="text"
                :title="conversation.lastMessage.messageForShow"
                >{{ conversation.lastMessage.messageForShow }}</span
              >
            </div>
          </a-col>
          <a-col>
            <div class="date">{{ date }}</div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers("im");
export default {
  name: "conversation-item",
  props: ["conversation"],
  data() {
    return {
      hasMessageAtMe: false,
      face: require("@/assets/avatar.png")
    };
  },
  computed: {
    showUnreadCount() {
      // 是否显示未读计数。当前会话和未读计数为0的会话，不显示。
      return (
        this.currentConversation.conversationID !==
          this.conversation.conversationID && this.conversation.unreadCount > 0
      );
    },
    date() {
      if (
        !this.conversation.lastMessage ||
        !this.conversation.lastMessage.lastTime
      ) {
        return "";
      }
      const date = moment(this.conversation.lastMessage.lastTime * 1000);
      if (date.date() === moment().date()) {
        return date.format("HH:mm");
      }
      return date.format("YYYY-MM-DD");
    },
    avatar: function() {
      switch (this.conversation.type) {
        case "GROUP":
          return this.conversation.groupProfile.avatar;
        case "C2C":
          return this.conversation.userProfile.avatar;
        default:
          return "";
      }
    },
    conversationName: function() {
      if (this.conversation.type === this.$TIM.TYPES.CONV_C2C) {
        return (
          this.conversation.userProfile.nick ||
          this.conversation.userProfile.userID
        );
      }
      if (this.conversation.type === this.$TIM.TYPES.CONV_GROUP) {
        return (
          this.conversation.groupProfile.name ||
          this.conversation.groupProfile.groupID
        );
      }
      if (this.conversation.type === this.$TIM.TYPES.CONV_SYSTEM) {
        return "系统通知";
      }
      return "";
    },
    showGrayBadge() {
      if (this.conversation.type !== this.$TIM.TYPES.CONV_GROUP) {
        return false;
      }
      return (
        this.conversation.groupProfile.selfInfo.messageRemindType ===
        "AcceptNotNotify"
      );
    },
    ...mapState(["currentConversation"]),
    ...mapGetters(["toAccount"])
  },
  methods: {
    ...mapActions(["checkoutConversation"]),
    selectConversation() {
      if (
        this.conversation.conversationID !==
        this.currentConversation.conversationID
      ) {
        this.checkoutConversation(this.conversation.conversationID);
      }
    },
    deleteConversation(event) {
      // 停止冒泡，避免和点击会话的事件冲突
      this.$tim
        .deleteConversation(this.conversation.conversationID)
        .then(() => {
          this.$store.commit("showMessage", {
            message: `会话【${this.conversationName}】删除成功!`,
            type: "success"
          });
          this.popoverVisible = false;
          this.$store.commit("resetCurrentConversation");
        })
        .catch(error => {
          this.$store.commit("showMessage", {
            message: `会话【${this.conversationName}】删除失败!, error=${error.message}`,
            type: "error"
          });
          this.popoverVisible = false;
        });
    }
  },
  watch: {
    currentConversation(next) {
      if (next.conversationID === this.conversation.conversationID) {
        this.hasMessageAtMe = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.conversation-item-container {
  padding: 8px 12px;
  cursor: pointer;
  position: relative;
  // background: #ebebeb;
  overflow: hidden;
  .close-btn {
    position: absolute;
    right: 12px;
    top: -20px;
    color: #76828c;
    transition: all 0.2s ease;
    &:hover {
      color: #da271b;
    }
  }
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .name {
    font-size: 16px;
    max-width: 200px;
  }
  .msg {
    max-width: 200px;
    font-size: 12px;
    color: #76828c;
  }
  .date {
    font-size: 12px;
    color: #76828c;
  }
  &:hover {
    // background: #d7d7d7;
    .close-btn {
      top: 5px;
    }
  }
  &.choose {
    background: #ebebeb;
  }
}
</style>
